<template>
  <el-steps :active="active" align-center>
    <el-step title="受付番号確認"></el-step>
    <el-step title="商品・お届先入力"></el-step>
    <el-step title="受付内容確認"></el-step>
    <el-step title="受付完了"></el-step>
  </el-steps>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component({})
export default class AppSteps extends AppComponent {
  @Prop({ required: true })
  active;
}
</script>



// WEBPACK FOOTER //
// src/app/parts/ex/AppSteps.vue